import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const MileageInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Mileage Information">
            <DataRow
                label="Miles Per Year"
                value={String(pdfData.mileage_allowance)}
            />
            <DataRow
                label="Additional Purchased Miles (per year)"
                value={String(pdfData.additional_miles)}
                variant="muted"
            />
            <DataRow
                label="Cost Per Mile"
                value={pdfData.cost_per_mile.toDollarFormat()}
                variant="muted"
            />
            <DataRow
                label="Total Additional Miles Charge"
                value={pdfData.additional_miles_charge.toDollarFormat()}
                variant="muted"
            />
            <DataRow
                label="Total Mileage Allowed"
                value={String(pdfData.total_mileage_allowed)}
                isLast
            />
        </Panel>
    )
}
